<template>
    <div class="addAndModify">
        <el-container>
            <el-main ref="main" class="tabWrap">
                <el-tabs  v-model="activeName" style="width: 100%">
                    <el-tab-pane label="基本信息" name="Tab1" style="overflow-y: auto">
                        <el-form class="dataFormBox" :rules="rules" :inline="true" :model="dataForm">
                            <el-row>
                                <el-col :span="8">
                                    <el-form-item label-width="180px" label="项目：" prop="projectId">
                                        <el-select v-model="dataForm.projectId" style="width: 100%;" placeholder="请选择项目" :disabled="sporadicType == 2" filterable @change="getSubInfoByProjectIdList">
                                            <el-option :label="allProjectItem.name" :value="allProjectItem.id" v-for="(allProjectItem,allProjectIndex) in allProjectList" :key="'allProject'+allProjectIndex"></el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="8">
                                    <el-form-item label-width="180px" label="合同编号：" prop="subContractId">
                                        <el-select v-model="dataForm.subContractId" style="width: 100%;" placeholder="请选择合同编号" :disabled="sporadicType == 2" filterable @change="getSporadicProjectInfo">
                                            <el-option :label="subInfoItem.serialNumber" :value="subInfoItem.id" v-for="(subInfoItem,subInfoIndex) in subInfoList" :key="'subInfoItem'+subInfoIndex"></el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="8">
                                    <el-form-item label-width="180px" label="合作单位：">
                                        <el-input v-model="dataForm.partyB" placeholder="请输入合作单位" :readonly="true" clearable></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="8">
                                    <el-form-item label-width="180px" label="合同金额：">
                                        <el-input v-model="dataForm.amount" placeholder="请输入合同金额" :readonly="true" clearable></el-input>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="16">
                                    <el-form-item label-width="180px" label="合同内容：">
                                        <el-input
                                                type="textarea"
                                                placeholder="请输入内容"
                                                v-model="dataForm.subContent"
                                                :readonly="true"
                                                maxlength="100"
                                                show-word-limit>
                                        </el-input>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="8">
                                    <el-form-item label-width="180px" label="提报人：">
                                        <el-input v-model="dataForm.userName" placeholder="请输入提报人" :readonly="true" clearable></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="8">
                                    <el-form-item label-width="180px" label="提报部门：">
                                        <el-input v-model="dataForm.userDeptName" placeholder="请输入提报部门" :readonly="true" clearable></el-input>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="8">
                                    <el-form-item label-width="180px" label="零星工程对应清单号：" prop="listNo">
                                        <el-input v-model="dataForm.listNo" placeholder="请输入零星工程对应清单号" clearable></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="8">
                                    <el-form-item label-width="180px" label="内部定额小组确认：" prop="confirmType">
                                        <el-select v-model="dataForm.confirmType" style="width: 100%;" placeholder="请选择内部定额小组确认">
                                            <el-option :label="confirmItem.name" :value="confirmItem.id" v-for="(confirmItem,confirmIndex) in confirmList" :key="'confirmItem'+confirmIndex"></el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="16">
                                    <el-form-item label-width="180px" label="零星工程简要描述：" prop="content">
                                        <el-input
                                                type="textarea"
                                                placeholder="请输入零星工程简要描述"
                                                v-model="dataForm.content"
                                                maxlength="500"
                                                rows=10
                                                show-word-limit>
                                        </el-input>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                        </el-form>
                    </el-tab-pane>
                    <el-tab-pane label="附件" name="Tab2" style="overflow-y: auto">
                        <upload-file
                                :tableList="fileList"
                                @submit="doSubmitFiles">
                        </upload-file>
                    </el-tab-pane>
                    <el-tab-pane label="审批流程" name="Tab3" style="overflow-y: auto">
                        <el-form
                                ref="approveRef"
                                :model="approveForm"
                                label-width="120px"
                                style="text-align: left;">
                            <el-form-item
                                    v-for="(item, index) in approveList"
                                    :key="index"
                                    :label="`${item.jobName}：`"
                                    required>
                                <el-input style="width: 70%;" v-model="item.approveUserName" clearable></el-input>
                                <el-button @click="selectApproveTarget(item)" type="primary">选择</el-button>
                            </el-form-item>
                        </el-form>
                    </el-tab-pane>
                </el-tabs>
            </el-main>
            <el-footer class="container">
                <div class="btnMid">
                    
                    <el-button type="primary" @click="submitForm(true)">暂 存</el-button>
                    <el-button type="primary" @click="submitForm(false)">提 交</el-button>
                    <el-button type="info" @click="close()">取 消</el-button>
                </div>
            </el-footer>
        </el-container>

        <approve-dialog
                :visible="approveDialogVisible"
                @close="approveDialogClose"
                title="选择审批人员"
                v-bind="approveDialogOptions"
        ></approve-dialog>
    </div>
</template>

<script>
    import UploadFile from "./UploadFile";
    import ApproveDialog from "@/page/meeting/bill/ApproveDialog";
    import Consts from "@/utils/consts";

    import {
        addSporadicProjectService,
        modifySporadicProjectService,
        createApproveProcessService,
        getSporadicProjectInfoService,
        getAllProjectPassListService
    } from "@/services/engineering";
    import {getApproveListService,getOrgIdService} from "@/services/sysSettingService";
    import {
        querySubInfoByProjectIdService
    } from "@/services/invoiceServices";
    export default {
        name: "addAndModify",
        data() {
            return {
                activeName: 'Tab1',
                sporadicType: 0, // 1-新增 2-修改
                dataForm: {
                    id: '',
                    projectId: '',
                    subContractId: '',
                    partyB: '',
                    partyBId: '',
                    amount: '',
                    subContent: '',
                    userName: '',
                    userDeptName: '',
                    listNo: '',
                    confirmType: '',
                    content: '',
                },
                rules: {
                    projectId: [
                        { required: true, message: '请选择项目', trigger: 'change' },
                    ],
                    subContractId: [
                        { required: true, message: '请选择合同编号', trigger: 'change' },
                    ],
                    listNo: [
                        { required: true, message: '请输入零星工程对应清单号', trigger: 'blur' },
                    ],
                    confirmType: [
                        { required: true, message: '请选择内部定额小组确认', trigger: 'change' },
                    ],
                    content: [
                        { required: true, message: '请输入零星工程简要描述', trigger: 'blur' },
                    ],
                },
                allProjectList: [],
                subInfoList: [],

                fileList:[],
                confirmList: [{
                    name: '是',
                    id: 'NEED_CONFIRM',
                },{
                    name: '否',
                    id: 'NOT_NEED_CONFIRM',
                }],

                approveDialogVisible: false,
                approveDialogOptions: {
                    approveVO: {},
                }, // 审批流弹出框的配置
                approveForm: {
                    headOfDepart: {
                        // 部门负责人
                        id: null,
                        name: "",
                    },
                    leaderOfCompany: {
                        // 集团分管领导
                        id: null,
                        name: "",
                    },
                }, // 审批流程
                approveList: [], // 审批流列表

            }
        },
        components: {
            UploadFile,
            ApproveDialog,
        },
        methods: {
            onActive(menuCode) {
                console.log(this.tabRouteParam)
                if(this.tabRouteParam.id){
                    this.dataForm.id = this.tabRouteParam.id;
                    this.getSporadicDetail();
                }else{
                    this.getUserInfo();
                }
                this.sporadicType = this.tabRouteParam.sporadicType
                this.initApproveList(); // 新建提报单，要先去获取一次审批流模板
                this.getAllProjectPassList();
            },
            // 查询项目列表
            getAllProjectPassList(){
                getAllProjectPassListService().then( res => {
                    if(res.code == 10000000){
                        this.allProjectList = res.data;
                    }else{
                        this.$message.error(res.msg);
                    }
                }).catch(error => {
                    this.$message.error("网络请求失败");
                });
            },
            // 查询合同列表
            getSubInfoByProjectIdList(bool = true){
                let params = {
                    projectId: this.dataForm.projectId
                }
                querySubInfoByProjectIdService(params).then( res => {
                    if(res.code == 10000000){
                        if(bool){
                            this.dataForm.subContractId = ''
                        }
                        this.subInfoList = res.data;
                    }else{
                        this.$message.error(res.msg);
                    }
                }).catch(error => {
                    this.$message.error("网络请求失败");
                });
            },
            getSporadicDetail(){
                let params = {
                    id: this.dataForm.id
                }
                getSporadicProjectInfoService(params).then(res => {
                    if (res.code == 10000000){
                        this.projectinfo = res.data;
                        this.dataForm = {
                            ... this.dataForm,
                            projectId: Number(res.data.projectId),
                            subContractId: res.data.subContractId,
                            partyB: res.data.partyB,
                            partyBId: res.data.partyBId,
                            amount: res.data.contractAmount,
                            subContent: res.data.contractContent,
                            userName: res.data.applyUserName,
                            userDeptName: res.data.applyDeptName,
                            listNo: res.data.listNo,
                            confirmType: res.data.confirmType,
                            content: res.data.content,
                        }
                        this.fileList = res.data.sporadicProjectItemsVOList;
                        this.getSubInfoByProjectIdList(false);
                    }
                })
            },
            getSporadicProjectInfo(val){
                let index = this.subInfoList.findIndex(item => item.id == val)
                let data = this.subInfoList[index];
                this.dataForm.partyB = data.partyB
                this.dataForm.partyBId = data.partyBId
                this.dataForm.amount = data.amount
                this.dataForm.subContent = data.content
            },
            getUserInfo(){
                let params = {
                    userId: sessionStorage.getItem('currentUserId')
                }
                getOrgIdService(params).then( res => {
                    if(res.code == 10000000){
                        this.dataForm.userName = res.data.displayName;
                        this.dataForm.userDeptName = res.data.deptDisplayName;
                    }else{
                        this.$message.error(res.msg);
                    }
                }).catch(error => {
                    this.$message.error("网络请求失败");
                });
            },
            /**
             * 获取审批流列表
             * */
            initApproveList() {
                let params = {
                    orgId: sessionStorage.getItem("orgId"),
                    type: "sporadic",
                };
                getApproveListService(params)
                    .then((res) => {
                        if (res.code == Consts.Code_OK) {
                            let list = res.data || [];
                            list.forEach((item) => {
                                item.approveUserId = null;
                                item.approveUserName = "";
                                item.deptId = null;
                                item.deptName = "";
                                item.sort = item.sortId;
                            });
                            list.sort((a, b) => {
                                return a.sortId - b.sortId;
                            }); // 按照sortId排序，从小到大
                            this.approveList = [...list];
                        } else if (res.code == Consts.Code_Err) {
                            this.$alert(res.msg, "提示");
                        } else {
                            this.$alert(Consts.Err_Msg, "提示");
                        }
                    })
                    .catch((error) => {
                        this.$message.error(Consts.Err_Msg);
                    });
            },
            selectApproveTarget(item) {
                // 选择对应的审批人
                this.approveDialogOptions = {
                    approveVO: item,
                };
                this.approveDialogVisible = true;
            },
            approveDialogClose(data) {
                console.log("审批流程,关闭", data);
                this.approveDialogVisible = false;
                if (data) {
                    // 选了人了
                    this.approveList.forEach((item) => {
                        if (item.jobId == data.jobId) {
                            item.approveUserId = data.id;
                            item.approveUserName = data.displayName || data.name;
                            item.deptId = data.deptId;
                            item.deptName = data.deptDisplayName;
                            // item.jobId = data.jobId;
                            // item.jobName = data.jobName;
                        }
                    });
                }
            },

            submitForm(boolean){
                if(!this.dataForm.projectId || !this.dataForm.subContractId || !this.dataForm.partyB||
                    !this.dataForm.listNo || !this.dataForm.confirmType || !this.dataForm.content){
                    this.$message.error('请完善基本信息');
                    return
                }
                if(!boolean){
                    let isApprove = this.approveList.findIndex(item => item.approveUserId == null || item.approveUserId == ''|| item.approveUserName == '')
                    if(isApprove != -1){
                        this.$message.error('请完善审批流程');
                        return
                    }
                }

                let params = {
                    ...this.dataForm,
                    isTempSave: boolean,
                    sporadicProjectItemsDtoList: this.fileList,
                }
                if(this.sporadicType == 1){
                    this.addSporadicProject(params, boolean);
                }else {
                    this.modifySporadicProject(params, boolean);
                }
            },
            addSporadicProject(params, boolean){
                addSporadicProjectService(params).then( res => {
                    if(res.code == 10000000){
                        if(!boolean){
                            this.$message.success('提交成功');
                            this.createApprove(res.data);
                        }else{
                            this.$message.success('暂存成功');
                            this.close();
                        }
                    }else{
                        this.$message.error(res.msg);
                    }
                }).catch(error => {
                    this.$message.error("网络请求失败");
                });
            },
            modifySporadicProject(params, boolean){
                modifySporadicProjectService(params).then( res => {
                    if(res.code == 10000000){
                        if(!boolean){
                            this.$message.success('修改成功');
                            this.createApprove(this.dataForm.id);
                        }else {
                            this.$message.success('暂存成功');
                            this.close();
                        }
                    }else{
                        this.$message.error(res.msg);
                    }
                }).catch(error => {
                    this.$message.error("网络请求失败");
                });
            },
            //创建审批流
            createApprove(id){
                let projectIndex = this.allProjectList.findIndex(item => item.id == this.dataForm.projectId)
                let projectName = this.allProjectList[projectIndex].name;
                let params = {
                    approveClass: 'SPORADIC_PROJECT',
                    approveProcessDtoList: this.approveList,
                    approveStatusEnum:'UNDERAPLLY',
                    projectId: this.dataForm.projectId,
                    itemId: id,
                    itemName: `${sessionStorage.getItem('name')}关于${projectName}（${this.dataForm.partyB}）的零星工程量申请`,
                }
                createApproveProcessService(params).then((res) => {
                    if (res.code == Consts.Code_OK) {
                        this.close();
                    } else if (res.code == Consts.Code_Err) {
                        this.$alert(res.msg, "提示");
                    } else {
                        this.$alert(Consts.Err_Msg, "提示");
                    }
                }).catch((error) => {
                    this.$message.error(Consts.Err_Msg);
                });
            },
            doSubmitFiles(files) {
                this.fileList = files;
            },
            // 关闭按钮
            close(){
                if(this.sporadicType == 1 ){
                    this.bus.$emit("tabClose", "sporadicAdd");
                    this.bus.$emit("navMenuChange", {
                        routeId: "sporadicIndex"
                    });
                }else {
                    this.bus.$emit("tabClose", "sporadicModify");
                    this.bus.$emit("navMenuChange", {
                        routeId: "sporadicIndex"
                    });
                }
            },
        }
    }
</script>

<style scoped lang="scss">
    @import "@/assets/css/commonLayout.scss";
    .addAndModify {
        height: 100%;
        background-color: white;
        display: flex;
        flex-direction: column;
        .container{
            width: 900px;
        }
    }
    .tabWrap {
        height: calc(100% - 60px);

        /deep/ .el-tabs--top {
            height: 100%;
            overflow: hidden;

            .el-tabs__content {
                height: calc(100% - 80px);
                padding: 0 20px 20px;
                overflow: auto;

                .el-form-item {
                    width: 100%;
                }

                .el-checkbox {
                    line-height: 40px;
                }

                .el-textarea {
                    min-width: 0px !important;
                }
                .el-cascader {
                    width: 100%;
                }

                .el-form-item__content {
                    width: calc(100% - 180px);

                    .el-input {
                        width: 100%;
                    }
                }
            }
        }
    }
    /deep/.el-container .el-main{
        height: 100%;
    }
    /deep/.el-textarea{
        /*width: 600px;*/
    }
    /deep/.el-tabs__header{
        padding-right: 0 !important;
        .el-tabs__nav-wrap{
            padding-left: 30px;
        }
    }
    /deep/.el-input.is-disabled .el-input__inner{
        background-color: #fff !important;
        color: #606266 !important;
    }
    .sendList {
        /deep/.el-form-item{
            width: 100%;
            display: flex;
            .el-form-item__content {
                width: 70%;
                display: flex;
                .el-input {
                    flex: 1;
                }
                .el-button {
                    margin-left: 10px;
                    height: fit-content;
                }
            }
        }

        .tag-wrapper {
            border: 1px solid #dcdfe6;
            padding: 0 5px;
        }
    }
    .formItem{
        /deep/.el-form-item{
            display: flex;
            align-items: flex-start;
            .el-tree-node__content{
                padding-top: 6px;
            }
        }
    }
    .btnMid {
        width: 300px;
        margin: 0 auto;
        display: flex;
        justify-content: space-around;
    }
</style>
